<template>
    <div>
        <template v-if="!wapShow">
            <header-hove :tab-index="4"></header-hove>
            <div style="padding: 0 50px;background: #ffffff" class="aboutUs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="公司介绍" name="1">
                        <company-introduction></company-introduction>
                    </el-tab-pane>
                    <el-tab-pane label="职业机会" name="2">
                        <career-opportunities></career-opportunities>
                    </el-tab-pane>
                    <el-tab-pane label="联系我们" name="3">
                        <contact-us></contact-us>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <footers></footers>
        </template>
        <template v-else>
            <about-wap></about-wap>
        </template>
    </div>
</template>

<script>
    import Footers from "@/components/footer";
    import HeaderHove from "@/components/headerHove";
    import CompanyIntroduction from "@/views/aboutUs/component/CompanyIntroduction";
    import ContactUs from "@/views/aboutUs/component/contactUs";
    import CareerOpportunities from "@/views/aboutUs/component/careerOpportunities";
    import eventBus from "@/assets/js/eventBus";
    import aboutWap from "./wap/index"
    export default {
        name: "aboutUs",
        components:{CareerOpportunities, ContactUs, CompanyIntroduction, HeaderHove, Footers,aboutWap},
        data(){
            return{
                activeName:"1",
                wapShow:false
            }
        },
        watch:{
            '$route': function (to, from) {
                if(this.$route.query.type){
                    this.activeName = this.$route.query.type;
                }
            }
        },
        mounted() {
            if (this.$route.query.type) {
                this.activeName =this.$route.query.type;
            }
            if(this.$route.query.wapShow) this.wapShow = this.$route.query.wapShow;
            eventBus.$on("wapShow",(data)=>{
                this.wapShow= data;
            })
        },
        methods:{
            handleClick(){}
        }
    }
</script>

<style scoped>

</style>

<style>
    .aboutUs .el-tabs__active-bar{
        background: rgba(0, 103, 172, 1) !important;
    }
    .aboutUs .el-tabs__nav{
        width: 100% !important;
        border-bottom: 1px solid #E6E8EB;
    }
    .aboutUs .el-tabs__item{
        width: 366px !important;
        border: 0 !important;
        font-size: 16px !important;
        font-family: MicrosoftYaHei !important;
        color: #0067AC !important;
        background: #ffffff;
        height: 41px !important;
    }
    .aboutUs .el-tabs--border-card{
        border: 0 !important;
        box-shadow: none !important;
    }
</style>
